"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _theme = _interopRequireDefault(require("../../theme"));
var _excluded = ["variant", "spacing"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var StyledHr = (0, _styledComponents["default"])(function (_ref) {
  var variant = _ref.variant,
    spacing = _ref.spacing,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("hr", rest);
}).withConfig({
  displayName: "Divider__StyledHr",
  componentId: "sc-1xcaf9r-0"
})(["border-top:1px solid ", ";margin:", " 0;"], function (_ref2) {
  var variant = _ref2.variant;
  if (variant === 'secondary') return _theme["default"].neutral160;
  if (variant === 'tertiary') return _theme["default"].neutral140;
  return _theme["default"].indigo30;
}, function (_ref3) {
  var spacing = _ref3.spacing;
  return spacing;
});
var Divider = function Divider(_ref4) {
  var _ref4$variant = _ref4.variant,
    variant = _ref4$variant === void 0 ? 'primary' : _ref4$variant,
    _ref4$spacing = _ref4.spacing,
    spacing = _ref4$spacing === void 0 ? _theme["default"].space40 : _ref4$spacing;
  return /*#__PURE__*/_react["default"].createElement(StyledHr, {
    variant: variant,
    spacing: spacing
  });
};
Divider.propTypes = {
  variant: _propTypes["default"].oneOf(['primary', 'secondary', 'tertiary']),
  spacing: _propTypes["default"].string
};
var _default = exports["default"] = Divider;